import vueAnimateNumber from "./number/index";
const components = [vueAnimateNumber];
const install = function (Vue) {
  console.log(Vue);
  // 判断是否安装
  if (install.installed) return;
  components.map((component) => {
    Vue.component(component.name, component);
  });
  // 判断是否是直接引入文件
  if (typeof window !== "undefined" && window.Vue) {
    install(window.Vue);
  }
};
export default {
  // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
  install,
  // 以下是具体的组件列表
  vueAnimateNumber,
};
